module.exports = __webpack_public_path__ + "static/media/orderIcon.8794c7fa.svg";